import React from "react";
import logoEn from "../../images/ah-logo.webp";

// Self-contained page (no API / translations) so it keeps working while the backend is down
const MaintenancePage = () => (
  <div
    style={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px",
      textAlign: "center",
      background: "#f7f8fa",
      fontFamily: "inherit"
    }}
  >
    <img src={logoEn} alt="Autohub" style={{ maxWidth: 200, marginBottom: 32 }} />
    <h1 style={{ fontSize: 28, marginBottom: 12 }}>We&apos;ll be back soon</h1>
    <p style={{ fontSize: 16, color: "#555", maxWidth: 520 }}>
      Our website is currently undergoing scheduled maintenance. We apologize for the inconvenience
      and appreciate your patience.
    </p>
    <hr style={{ width: 80, margin: "28px auto" }} />
    {/* <h1 dir="rtl" style={{ fontSize: 28, marginBottom: 12 }}>
      سنعود قريباً
    </h1>
    <p dir="rtl" style={{ fontSize: 16, color: "#555", maxWidth: 520 }}>
      يخضع موقعنا حالياً لأعمال صيانة مجدولة. نعتذر عن الإزعاج ونشكركم على صبركم.
    </p> */}
  </div>
);

export default MaintenancePage;
